export default __webpack_public_path__ + "static/media/favicon-pcp.d9b07b30.ico";